import { IEventType } from '../typings/ieventtype.d';

export class EventType implements IEventType {
  id: number;
  name: string;
  constructor(){
    this.id = 0;
    this.name = '';
  }
}

export const EVENTTYPES : EventType[] = [
    {id:1, name:'ERROR'},
    {id:2, name:'WARNING'},
    {id:4, name:'INFORMATION'},
    {id:8, name:'SUCCESS AUDIT'},
    {id:16, name:'FAILURE AUDIT'}
];


